import React from 'react';
import { Section } from './Section';
import { Clock } from 'lucide-react';
export function Urgency() {
  return <Section className="py-8" data-id="element-193">
      <div className="max-w-4xl mx-auto bg-rose/10 rounded-2xl p-6 flex flex-col md:flex-row items-center gap-6 justify-center text-center md:text-left border border-rose/20" data-id="element-194">
        <div className="bg-white p-3 rounded-full flex-shrink-0 shadow-sm" data-id="element-195">
          <Clock className="w-6 h-6 text-rose-dark" data-id="element-196" />
        </div>
        <div data-id="element-197">
          <p className="font-medium text-brown-dark text-lg mb-1" data-id="element-198">
            Precio especial de lanzamiento por tiempo limitado.
          </p>
          <p className="text-brown-light" data-id="element-199">
            Una vez que termine esta etapa, el precio aumentará. Tu recuperación
            no puede esperar más.
          </p>
        </div>
      </div>
    </Section>;
}